var map = {
	"./arb.png": 62762,
	"./arrow-down-blue.svg": 14220,
	"./arrow-down-grey.svg": 70713,
	"./arrow-right-white.png": 76997,
	"./arrow-right.svg": 87095,
	"./aurora.png": 76383,
	"./base.png": 97188,
	"./bera.png": 43475,
	"./big_unicorn.png": 92060,
	"./blue-loader.svg": 22517,
	"./bnb.svg": 66103,
	"./boba.svg": 53897,
	"./bsc.png": 5335,
	"./circle-grey.svg": 29833,
	"./circle.svg": 36839,
	"./coinbaseWalletIcon.svg": 26919,
	"./dropdown-blue.svg": 97013,
	"./dropdown.svg": 94156,
	"./dropup-blue.svg": 53116,
	"./ethereum-logo.png": 45706,
	"./fortmaticIcon.png": 1223,
	"./ftm.png": 31508,
	"./hyperevm.png": 12471,
	"./link.svg": 15735,
	"./logo.png": 82806,
	"./magnifying-glass.svg": 83283,
	"./menu.svg": 34618,
	"./metamask.png": 73168,
	"./metis.png": 77293,
	"./mirror.png": 14274,
	"./noise.png": 83938,
	"./op.png": 79134,
	"./plus-blue.svg": 24352,
	"./plus-grey.svg": 64389,
	"./portisIcon.png": 55761,
	"./question-mark.svg": 57463,
	"./question.svg": 25275,
	"./soneium.svg": 35837,
	"./sonic.png": 98463,
	"./spinner.svg": 33126,
	"./taiko.svg": 86881,
	"./token-list-logo.png": 82587,
	"./token-list/lists-dark.png": 71312,
	"./token-list/lists-light.png": 37938,
	"./token-logo.png": 77558,
	"./tokenlistsgrouped.png": 731,
	"./trustWallet.png": 82282,
	"./u2u.jpg": 89529,
	"./viction.png": 2203,
	"./w-bera.png": 32347,
	"./walletConnectIcon.svg": 25177,
	"./x.svg": 61345,
	"./xl_uni.png": 82188
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 73811;